import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
//import NewsSlider from "./components/news-slider";
import ReviewsSlider from "./components/reviews-slider";
import PartnersSlider from "./components/partners-slider";
import DossiersSlider from "./components/dossiers-slider";
import HomeHeaderSlider from "./components/homeheader-slider";
import PortalPageSlider from "./components/portal-page-slider";
// import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import GallerySEction from "./components/gallery-section";
import ResourcesGrid from "./components/resources-grid";

import DeviceManager from "./utils/device-manager";

(function ($) {
	window.$ = $;

	$(function () {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}

        // Global option for jQuery lightbox
        if(window.lightbox) {
            lightbox.option({
                albumLabel: 'Image %1 sur %2',
                resizeDuration: 200,
                fadeDuration: 200
            });
        }

		// Handheld menu
		// const handheldMenu = new HandheldMenu();

		// General components
		const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);
		// const dropdownMenu = new DropdownMenu($('.header__nav'));

		// News slider component
		/*const $newsSliders = $(".news-slider");
		if ($newsSliders.length) {
			$newsSliders.each(function (index, el) {
				const newsSlider = new NewsSlider($(el));
			});
		}*/

		// Partners slider component
		const $partnersSliders = $(".partners-slider");
		if ($partnersSliders.length) {
			$partnersSliders.each(function (index, el) {
				const partnerSlider = new PartnersSlider($(el));
			});
		}

		// Home Header slider component
		const $homeHeaderSliders = $(".homepage-header__slider");
		if ($homeHeaderSliders.length) {
			$homeHeaderSliders.each(function (index, el) {
				const homeHeaderSlider = new HomeHeaderSlider($(el));
			});
		}

		// Dossiers slider component
		const $dossiersSliders = $(".dossiers__slider");
		if ($dossiersSliders.length) {
			$dossiersSliders.each(function (index, el) {
				const dossiersSlider = new DossiersSlider($(el));
			});
		}

		// Portal page slider component
		const $portalPageSliders = $(".portal-page__header-slider");
		if ($portalPageSliders.length) {
			$portalPageSliders.each(function (index, el) {
				const portalPageSlider = new PortalPageSlider($(el));
			});
		}

		// Reviews slider component
		const $reviewsSlider = $(".reviews__slider");
		if ($reviewsSlider.length) {
			$reviewsSlider.each(function (index, el) {
				const reviewsSlider = new ReviewsSlider($(el));
			});
		}

        // Resources grid component
        const $resourcesGrids = $(".resources-grid");
        if ($resourcesGrids.length) {
            $resourcesGrids.each(function (index, el) {
                const resourcesGrid = new ResourcesGrid($(el));
            });
        }

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		//Décalage du scroll
		var anchorLink = $(window.location.hash);
		
			if ( anchorLink.length ) {

				$("html, body").animate({scrollTop: anchorLink.offset().top - 140 }, 200);
		}

		function scrollToAnchor(hash) {
            var target = $(hash),
                headerHeight = 130; 

            if(target.parents('.scroll-in-view').hasClass('scroll-in-view--slide-y')) {
                if(target.parents('.scroll-in-view').hasClass('scroll-in-view-anim-ended')) {
                    headerHeight = 130;
                } else {
                    headerHeight = 260;
                }
            }

            if (target.length)
            {
                //console.log(target.offset().top, headerHeight, target.offset().top - headerHeight);
                $('html,body').animate({
                    scrollTop: target.offset().top - headerHeight
                }, 500);
                
                return false;
            }
        }

        $(window).on('fonts:ready', function() {
            //console.log('fonts:ready');
            if(window.location.hash) {
                scrollToAnchor(window.location.hash);
            }
        });

        $("a[href*=\\#]:not([href=\\#])").click(function(){
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
            || location.hostname == this.hostname)
            {
                scrollToAnchor(this.hash);
            }
        });


		$(".menu-toggler").click(function () {
			$(this).toggleClass('menu-toggler--opened');
			$('.handheld-header__nav-wrapper').toggleClass('menu--opened');
		});

		$('.handheld-header__nav a[href="#"]').click(function (e) {
			e.preventDefault();
		});

		$( ".header__nav .sub-menu > li > a" ).hover(
			function() {
			var color = $(this).find('span').attr('data-hover');
			  $( this ).css('color', color);
			}, function() {
			  $( this ).css('color', '#000');
			}
		  );
	});
})(jQuery);
